var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 6.75L17.75 3.75M17.75 3.75L14.75 0.75M17.75 3.75L14.75 6.75M17.75 3.75L20.75 0.75",
    stroke: "#C62828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 8.77944C9.12258 7.40685 11.348 7.40685 12.7206 8.77944C14.0931 10.152 14.0931 12.3774 12.7206 13.75",
    stroke: "#C62828",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60289 17.8971C6.79869 21.0929 11.6627 21.6038 15.3918 19.4297C16.2785 18.9127 16.7219 18.6543 16.749 18.1282C16.7761 17.6022 16.2777 17.2382 15.281 16.5103C13.433 15.1607 11.6136 13.5103 9.80163 11.6984C7.98967 9.88641 6.33927 8.06705 4.98969 6.21904C4.26179 5.22231 3.89784 4.72395 3.37178 4.75105C2.84572 4.77815 2.58725 5.22149 2.07031 6.10818C-0.103763 9.83731 0.407095 14.7013 3.60289 17.8971Z",
    stroke: "#C62828",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.9f43297a2cd5af976c999c7c6fdee68e.svg";
export { ForwardRef as ReactComponent };